import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import Reports from "../../assets/images/reports.svg";
import "./styles.scss";
import { DateRangePicker } from "react-date-range";
import { useState } from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { enGB } from "date-fns/locale";
import { useIsMobile } from "shared/hooks/useIsMobile";
import { format } from "date-fns";
import { Report_Types } from "shared/config/constants";
import { reportService } from "services";
import { ReportError } from "shared/errors";
import { handleError } from "shared/errors/handleError";
import { Circles } from "react-loader-spinner";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";

const Report = ({ setShowReport }) => {
  const isMobile = useIsMobile();
  const [customDate, setCustomDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateSelected, setDateSelected] = useState();
  const [reportTypeSelected, setReportTypeSelected] = useState();
  const [loader, setLoader] = useState(false);
  
  const togglePicker = () => {
    setShowDatePicker(prev => !prev);
  };

const formatDateSelected = (date) => {
  const startDate = format(date.startDate, "dd MMM yyyy");
  const endDate = format(date.endDate, "dd MMM yyyy");
  return `${startDate} - ${endDate}`;
};

const handleDateChange = async () => {
  const range = customDate[0];

  range.startDate = new Date(Date.UTC(
    range.startDate.getFullYear(),
    range.startDate.getMonth(),
    range.startDate.getDate(),
    0, 0, 0, 0
  ));

  range.endDate = new Date(Date.UTC(
    range.endDate.getFullYear(),
    range.endDate.getMonth(),
    range.endDate.getDate(),
    23, 59, 59, 999
  ));

  const formattedDate = formatDateSelected(range);
  setDateSelected(formattedDate);
  setShowDatePicker(false);
};

const handleDownloadReport = async () => {
    setLoader(true);
    try {
      const response = await reportService.downloadreport(
        {
        type: reportTypeSelected,
        start_utc: customDate[0].startDate.toISOString(),
        end_utc: customDate[0].endDate.toISOString(),
        output: "EXCEL",
      }
    );

      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const fileExtension = ".xlsx";
      const fileName = `HelloApp_${reportTypeSelected}_${formatDateSelected(
        customDate[0]
      )}.xlsx`;

      // const ws = XLSX.utils.json_to_sheet([response.data]);
      // const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([response.data], { type: fileType });
      saveAs(data, fileName);
      setLoader(false);
      // setShowReport(false);
      toast.success("Report downloaded successfully.");
    } catch (err) {
      if (err instanceof ReportError) {
        setLoader(false);
        handleError(err, {
           showToast: true,
          });
      }
    }
  };

  return (
    <Modal
      centered
      show={true}
      className="modal-lg reports-modal"
      backdropClassName="modal-backdrop"
      contentClassName="rounded-5"
    >
      <div className="text-center p-4">
        {
        <div className="bold">
          <img src={Reports} alt="Reports" /> Reports
        </div>
        }
        <div>
          <div className="content">
            <div className="d-flex justify-content-start flex-column">
              <Form.Label>Report Type</Form.Label>

              <Form.Select
                aria-label="report type"
                size="lg"
                onChange={(val) =>
                  setReportTypeSelected(
                    val.target.value !== "Select" ? val.target.value : null
                  )
                }
              >
                <option>Select</option>
                {Report_Types.map((val) => (
                  <option value={val.value}>{val.name}</option>
                ))}
              </Form.Select>
            </div>
            <div className="d-flex justify-content-start flex-column date-input">
              <Form.Label>Select Date</Form.Label>
              <span onClick={togglePicker}></span>
              <Form.Control
                type="text"
                placeholder="Select"
                value={dateSelected}
                onClick={togglePicker}
                onFocus={togglePicker}
                aria-label="Select Date"
              />
              <div className="position-relative">
                {showDatePicker && (
                  <div className="date-range">
                    <DateRangePicker
                      ranges={customDate}
                      months={isMobile ? 1 : 2}
                      showPreview={false}
                      direction="horizontal"
                      onChange={(item) => setCustomDate([item.selection])}
                      locale={enGB}
                      showDateDisplay={false}
                      maxDate={new Date()}
                      color="#fff"
                    />
                    <div className="d-flex gap-4 p-2 justify-content-evenly bg-white">
                      <Button
                        variant="outline-dark" className="m-2"
                        onClick={() => setShowDatePicker(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" className="m-2" onClick={handleDateChange}>
                        Done
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex gap-4 btngroup py-4">
            <Button variant="outline-dark"  onClick={() => setShowReport(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleDownloadReport}
              disabled={!reportTypeSelected || !dateSelected}
            >
              Download Report
            </Button>
          </div>
        </div>
        {loader && (
          <div className="loader">
            <Circles
              height="80"
              width="80"
              color="#13294B"
              ariaLabel="bars-loading"
              visible={true}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default Report;
